<template>
  <div id="switch-trip">
    <div class="buisness-travel df-jsb-aic" :class="{ 'mt2': !isPhone }">
      <h3 class="raleway-semi-p13 mb-0">Kids-friendly <span v-if="getFilterCount('kids_friendly')" class="filter-count">({{ getFilterCount('kids_friendly') }})</span></h3>
      <input type="checkbox" id="Kids-friendly" v-model="selected" :value="43" @change="updateFilter" />
      <label class="m-0" for="Kids-friendly">Kids-friendly</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'switch-kids',
  props: ['filterCounts'],
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    updateFilter() {
      const isSelected = this.selected.length > 0;
      this.$emit('checked', isSelected ? [43] : [], 'eq_services_entiers');
      this.$emit('checked', isSelected ? [136] : [], 'eq_services');
      console.log("Kids-friendly updated:", this.selected);
    },
    getFilterCount(filterType) {
      if (!this.filterCounts) return 0;

      let count = 0;

      if (this.filterCounts.service_entiers_ids) {
        const serviceEntierData = this.filterCounts.service_entiers_ids.find(s => s.key === 43);
        if (serviceEntierData) count += serviceEntierData.count;
      }

      if (this.filterCounts.service_ids) {
        const serviceData = this.filterCounts.service_ids.find(s => s.key === 136);
        if (serviceData) count += serviceData.count;
      }

      return count;
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #436;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>